import moment from "moment";

export const getServiceURL = () => {
  let SERVICE_URL = "http://localhost:3010/v1";

  let IS_LOCALHOST = window.location.hostname.includes("localhost");

  if (!IS_LOCALHOST) {
    SERVICE_URL = process.env.REACT_APP_SERVICE_API;
  }
  return SERVICE_URL;
};

export const isMobileView = () => {
  return window.innerWidth <= 768;
};

export function isImageUrl(url) {
  return `${url}`?.match(/\.(jpeg|jpg|gif|png|avif|webp)/) != null;
}

export function isVideoUrl(url) {
  return `${url}`?.match(/\.(mp4|webm|ogg|mov)$/i) != null;
}

export const getTimeAgo = (date) => {
  const propsDate = moment(date);

  const now = moment();

  // Calculate the difference in minutes
  const minutesDifference = now.diff(propsDate, "minutes");

  // Calculate the difference in hours
  const hoursDifference = now.diff(propsDate, "hours");

  // Calculate the difference in days
  const daysDifference = now.diff(propsDate, "days");

  if (minutesDifference < 60) {
    return `${minutesDifference} minute${minutesDifference > 1 ? "s" : ""} ago`;
  } else if (hoursDifference < 24) {
    return `${hoursDifference} hour${hoursDifference > 1 ? "s" : ""} ago`;
  } else {
    return `${daysDifference} day${daysDifference > 1 ? "s" : ""} ago`;
  }
};

export function formatDateToDDMMYYYY(dateString) {
  const date = new Date(dateString); // Convert string to Date object
  const day = String(date.getDate()).padStart(2, "0"); // Get day with leading zero
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Get month with leading zero
  const year = date.getFullYear(); // Get year
  return `${day}-${month}-${year}`; // Return formatted string
}

export const getOptionNameById = (id, list = []) => {
  if (!id) return "";
  const safeList = Array.isArray(list) ? list : [];
  const item = safeList.find((opt) => opt.value === id);
  return item ? item.label : id;
};
